import { __rest } from '../node_modules/tslib/tslib.es6.mjs.js';
import React__default from 'react';
import classNames from 'classnames';
import { Text } from '../Text/Text.js';
import LinkAdapter from '../Link/Link.js';
import { FontAwesomeIcon } from '../node_modules/@breville-fortawesome/react-fontawesome/index.es.js';
import { faArrowDown, faClose, faCodeCompare, faDownload, faSliders, faArrowDownWideShort, faPlay, faPlus, faMinus, faCircleInfo, faAngleLeft, faArrowRight, faArrowUpArrowDown, faBarsFilter, faTrash, faChevronLeft, faChevronRight, faChevronUp, faChevronDown, faCheck, faArrowUpRight } from '../node_modules/@breville-fortawesome/pro-light-svg-icons/index.mjs.js';
import { faFacebook, faInstagram } from '../node_modules/@breville-fortawesome/free-brands-svg-icons/index.mjs.js';
import { applyTheme } from '../Theme/Theme.js';
import { faComment } from '../node_modules/@breville-fortawesome/pro-regular-svg-icons/index.mjs.js';

const ButtonV2 = (props) => {
    const { className, children, text = '', href, icon, size = 'lg', iconSize = (size === 'lg' ? 18 : 16), alignIcon = 'left', variant = 'brandbg', fill = 'filled', shape = '', selected = false, faIcon, openInNewTab, underLineOnHover, type = 'button', isNative = false, onClick = () => void (0), theme = 'inherit', modalID } = props, restOfProps = __rest(props, ["className", "children", "text", "href", "icon", "size", "iconSize", "alignIcon", "variant", "fill", "shape", "selected", "faIcon", "openInNewTab", "underLineOnHover", "type", "isNative", "onClick", "theme", "modalID"]), classNames$1 = classNames(applyTheme(theme), 'xps-btnv2', `btn-${size}`, `btn-${variant}`, shape ? `btn-shape-${shape}` : '', icon ? `btn-icon-align-${alignIcon} xps-${size}btnV2-${alignIcon}-icon` : icon, faIcon && !icon ? `btn-icon-align-${alignIcon} xps-${size}btnV2-${alignIcon}-icon` : '', fill !== 'filled' ? `btn-fill-${fill}` : '', selected ? 'selected' : '', !text && icon ? 'xps-btnv2-icon-only' : '', underLineOnHover ? 'btn-fill-borderless-no-underline' : '', className);
    const textType = size === 'sm' ? 'p3-bold' : 'p2-bold';
    const iconMap = {
        arrowdown: faArrowDown,
        close: faClose,
        compare: faCodeCompare,
        download: faDownload,
        facebook: faFacebook,
        filter: faSliders,
        instagram: faInstagram,
        sort: faArrowDownWideShort,
        play: faPlay,
        plus: faPlus,
        minus: faMinus,
        info: faCircleInfo,
        arrowleft: faAngleLeft,
        arrowright: faArrowRight,
        arrowUpArrowDown: faArrowUpArrowDown,
        barFilter: faBarsFilter,
        trash: faTrash,
        chevronLeft: faChevronLeft,
        chevronRight: faChevronRight,
        chevronUp: faChevronUp,
        chevronDown: faChevronDown,
        comment: faComment,
        check: faCheck,
        arrowUpRight: faArrowUpRight
    };
    const isChildString = typeof children === 'string';
    const getButtonElements = () => {
        return React__default.createElement(React__default.Fragment, null,
            faIcon && React__default.createElement(FontAwesomeIcon, { icon: faIcon, style: { width: iconSize, height: iconSize } }),
            (icon && !faIcon) && React__default.createElement(FontAwesomeIcon, { icon: iconMap[icon], style: { width: iconSize, height: iconSize } }),
            text && React__default.createElement(Text, { tag: 'span', type: textType }, text),
            isChildString ? React__default.createElement(Text, { tag: 'span', type: textType }, children) : children,
            variant === 'playStore' && React__default.createElement("span", { className: 'btn-play-store-img' }),
            variant === 'appStore' && React__default.createElement("span", { className: 'btn-app-store-img' }));
    };
    const isExternal = href === null || href === void 0 ? void 0 : href.includes('http');
    function handleClick(e) {
        if (modalID) {
            const openModalEvent = new CustomEvent('openModal', { detail: { modalID } });
            window.dispatchEvent(openModalEvent);
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }
    if (href && (isExternal || openInNewTab || isNative)) {
        return (
        // eslint-disable-next-line react/jsx-no-target-blank
        React__default.createElement("a", Object.assign({ role: 'button', href: href, className: classNames$1, target: openInNewTab ? '_blank' : '_self' }, restOfProps), children !== null && children !== void 0 ? children : getButtonElements()));
    }
    if (href) {
        return (React__default.createElement(LinkAdapter, Object.assign({ role: 'button', href: href, className: classNames$1 }, restOfProps), children !== null && children !== void 0 ? children : getButtonElements()));
    }
    return (React__default.createElement("button", Object.assign({ type: type, className: classNames$1 }, restOfProps, { onClick: handleClick }), getButtonElements()));
};

export { ButtonV2 };
//# sourceMappingURL=ButtonV2.js.map
